import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CommonModule, NgOptimizedImage} from '@angular/common';

import {NgbCarouselConfig, NgbCarouselModule,} from '@ng-bootstrap/ng-bootstrap';
import {ListingMedia} from '../../../core/models/listing';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    NgbCarouselModule,
    RouterModule,
    CommonModule,
    NgbCarouselModule,
    NgOptimizedImage,
  ],
  selector: 'app-ngbd-carousel-config',
  templateUrl: 'carousel-config.html',
  styleUrls: ['./carousel-config.css'],
  providers: [NgbCarouselConfig], // add NgbCarouselConfig to the component providers
  encapsulation: ViewEncapsulation.None

})
export class NgbdCarouselConfigComponent implements OnInit {
  @Input() imageArr!: ListingMedia[];
  @Input() addressHyphenStr!: string;
  @Input() cityHyphenStr!: string
  @Input() MLSNum!: string;
  images = [700, 533, 807, 124].map((n) => `https://picsum.photos/id/${n}/900/500`);
  private supportsWebP = false;

  constructor(config: NgbCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = false;

    this.checkWebPSupport().then(supported => {
      this.supportsWebP = supported;
    });
  }

  private checkWebPSupport(): Promise<boolean> {
    if (typeof Image === 'undefined') {
      return Promise.resolve(false);
    }
    return new Promise(resolve => {
      const img = new Image();
      img.onload = () => resolve(img.width > 0 && img.height > 0);
      img.onerror = () => resolve(false);
      img.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    });
  }

  ngOnInit(): void {

    // console.log(this.imageArr);
    // console.log('hello world');
  }

  replaceImage(obj: { _elementObj: any; }) {
    // define properties
    const elementObj = obj._elementObj;

    // console.log(elementObj);
  }

  normalizeImageUrl(originalUrl: string): string {
    const format = this.supportsWebP ? 'webp' : 'jpg';
    if (!originalUrl) return '';
    return originalUrl
      .replace('fit-in/5000x5000', `fit-in/1200x1200/filters:format(${format}):quality(80)`)
      .replace('800x800', `fit-in/1200x1200/filters:format(${format}):quality(80)`)
      .replace('https://dhauv7lm2gh1r.cloudfront.net/rets_image_cache/muskoka_image_cache/', 'https://d2hg257h9htd0r.cloudfront.net/muskoka_image_cache/resized/medium-optimized/');
  }


}
